/* eslint-disable import/prefer-default-export */
import React from 'react'
import logo from 'images/logo/primaryLogo.png'
import missing from 'images/logo/white-on-black-wide.png'

import s from './ImageWrapper.module.css'

export function ImageWrapper(props) {
  const { image, url, listing } = props

  const {
    no_fee: noFee,
    rental,
    network,
    address: shortAddress,
  } = listing || {}

  const brokerageListing = network === 'brokerage'

  return (
    <a href={url} target="_blank" rel="noreferrer">
      <div className={s.imageWrapper}>
        <img
          className={s.image}
          src={image}
          alt={shortAddress}
          onError={(e) => {
            e.target.onerror = null
            e.target.src = missing
          }}
        />

        <div className={s.tags}>
          {brokerageListing && (
            <div className={s.nooklynHome}>
              <img alt="nooklyn" src={logo} className={s.nooklynLogo} />
            </div>
          )}

          {noFee && <div className={s.tag}>No Fee</div>}
          {!rental && <div className={s.tag}>For Sale</div>}
        </div>
      </div>
    </a>
  )
}
